import React, { useEffect, useState } from "react";
import { useIsFocused, useNavigation, useRoute } from "@react-navigation/native";
import i18n from "utils/i18n";
import _ from "lodash";
import { FormStatus } from 'utils/constants/form-constants';
import GraphqlBuilder from "utils/request/graphql/builder";
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from "components/atoms/ThemedLayout";
import LoadingComponent from "components/atoms/Loading";
import Translate from "utils/translate";
import { tableConstants } from "utils/constants/constants";
import QueryManagementFloor from "graphql/queries/management/QueryManagementFloor";
import HelperString from 'utils/helper-string'
import MutateTranslation from 'utils/mutate/translation'
import MutationManagementFloor from 'graphql/mutations/management/MutationManagementFloor'
import ObjectFloor from 'utils/objects/floor'
import HelperAvailability from "utils/helper/HelperAvailability";
import ManagementBuildingsComponentsTimeslotsScene from "scenes/management/buildings/components/timeslots";
import ManagementBuildingsComponentsTeamsScene from "scenes/management/buildings/components/teams";
import ManagementBuildingsComponentsEmployeeScene from "scenes/management/buildings/components/employees";
import ObjectTimeslot from "utils/objects/timeslot";
import HelperManagementRights from "utils/helper-management-rights";
import { managementRightsConstants } from "utils/constants/management-right-constants";
import FloorStatistics from 'scenes/management/buildings/components/floor/statistics'
import TabbedContent from 'components/molecules/TabbedContent'
import FloorData from 'scenes/management/buildings/components/floor/data'
import FloorRooms from 'scenes/management/buildings/components/floor/rooms'
import { AppRoutes } from 'navigations/app-routes'
import ManagementBuildingsComponentsTimeslotExceptionsScene from 'scenes/management/buildings/components/timeslotsExceptions'

const ManagementBuildingFloorScene = () => {
	
	const viewTabs = {
		STATISTICS: 'statistics',
		DATA: 'data',
		TIMESLOTS: 'timeslots',
		TIMESLOT_EXCEPTIONS: 'timeslot_exceptions',
		AVAILABLE_FOR_TEAMS: 'teams',
		AVAILABLE_FOR_EMPLOYEES: 'employees',
		ROOMS: 'rooms',
	};
	
	const isFocused = useIsFocused();
	const navigation = useNavigation();
	const route = useRoute();
	
	const [ loading, setLoading ] = useState( true )
	const [ floor, setFloor ] = useState( {} )
	const [ addedAvailableForEmployees, setAddedAvailableForEmployees ] = useState( [] )
	const [ addedAvailableForTeams, setAddedAvailableForTeams ] = useState( [] )
	
	const buildingGuid = _.get( route.params, 'buildingGuid', null );
	const floorGuid = _.get( route.params, 'floorGuid', null )
	
	const renderTabs = () => {
		const tabBarItems = [];
		
		if( floorGuid !== null ) {
			tabBarItems.push({
				key: viewTabs.STATISTICS,
				text: i18n.t( 'management:form_block.title_statistic_other' ),
				scene: ( props ) => {
					return (
						<FloorStatistics
							floor={ floor }
						/>
					);
				}
			})
		}
		
		tabBarItems.push( {
			key: viewTabs.DATA,
			text: i18n.t( 'management:form_block.title_default' ),
			scene: ( props ) => {
				return (
					<FloorData
						floor={ floor }
						saveForm={ saveForm }
					/>
				);
			}
		});
		
		if( floorGuid !== null ) {
			if( HelperManagementRights.hasViewRight( managementRightsConstants.VIEW.FLOOR_TIMESLOTS ) ) {
				tabBarItems.push( {
					key: viewTabs.TIMESLOTS,
					text: HelperString.addArrayLength( i18n.t( 'management:form_block.title_timeslot' ), ObjectTimeslot.groupTimeSlots( floor, {parse: true} ), false ),
					scene: ( props ) => {
						return (
							<ManagementBuildingsComponentsTimeslotsScene
								floor={ floor }
								onSubmit={ fetchFloor }
								readonly={ !HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.FLOOR_TIMESLOTS ) }
							/>
						);
					}
				});
				
				tabBarItems.push( {
					key: viewTabs.TIMESLOT_EXCEPTIONS,
					text: HelperString.addArrayLength( i18n.t( 'management:form_block.title_timeslot_exceptions' ) ),
					scene: ( props ) => {
						return (
							<ManagementBuildingsComponentsTimeslotExceptionsScene
								floor={ floor }
								onSubmit={ fetchFloor }
								readonly={ !HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.FLOOR_TIMESLOTS ) }
							/>
						);
					}
				});
			}
			
			if( HelperManagementRights.hasViewRight( managementRightsConstants.VIEW.FLOOR_TEAMS_EMPLOYEES ) ) {
				if ( floor.available_for === HelperAvailability.AVAILABLE_FOR_RESTRICTED ) {
					tabBarItems.push( {
						key: viewTabs.AVAILABLE_FOR_TEAMS,
						text: HelperString.addArrayLength( i18n.t( 'management:form_block.title_available_for_teams' ), addedAvailableForTeams, false ),
						scene: ( props ) => {
							return (
								<ManagementBuildingsComponentsTeamsScene
									floor={ floor }
									addedAvailableForTeams={ addedAvailableForTeams }
									onSubmit={ fetchFloor }
									readonly={ !HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.FLOOR_TEAMS_EMPLOYEES ) }
								/>
							);
						}
					});
				}
				
				if ( floor.available_for === HelperAvailability.AVAILABLE_FOR_RESTRICTED_EMPLOYEES ) {
					tabBarItems.push( {
						key: viewTabs.AVAILABLE_FOR_EMPLOYEES,
						text: HelperString.addArrayLength( i18n.t( 'management:form_block.title_available_for_employees' ), addedAvailableForEmployees, false ),
						scene: ( props ) => {
							return (
								<ManagementBuildingsComponentsEmployeeScene
									floor={ floor }
									addedAvailableForEmployees={ addedAvailableForEmployees }
									onSubmit={ fetchFloor }
									readonly={ !HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.FLOOR_TEAMS_EMPLOYEES ) }
								/>
							);
						}
					});
				}
				
				
			}
			
			if( HelperManagementRights.hasViewRight( managementRightsConstants.VIEW.ROOMS ) ) {
				tabBarItems.push( {
					key: viewTabs.ROOMS,
					text: HelperString.addArrayLength( i18n.t('management:form_block.title_room_other' ), _.get( floor, 'rooms', [] ), false ),
					scene: ( props ) => {
						return (
							<FloorRooms
								buildingGuid={ buildingGuid }
								floor={ floor }
							/>
						);
					}
				});
			}
		}
		
		return (
			<TabbedContent
				items={ tabBarItems }
			/>
		)
	}
	
	const fetchFloor = () => {
		if( floorGuid !== null ) {
			new GraphqlBuilder()
				.addQuery( 'query', QueryManagementFloor, {
					guid: floorGuid
				})
				.setResultPath( ['query', 'floor'], {} )
				.setOnSuccess( result => {
					let addedAvailableForEmployees = [];
					_.get( result, ['available_for_employees' ], [] ).forEach( ( employee ) => {
						addedAvailableForEmployees.push( employee.employee );
					});
					
					let addedAvailableForTeams = [];
					_.get( result, ['available_for_teams' ], [] ).forEach( ( team ) => {
						addedAvailableForTeams.push( team.team );
					});
					
					setAddedAvailableForEmployees( addedAvailableForEmployees )
					setAddedAvailableForTeams( addedAvailableForTeams )
					setFloor( result )
					setLoading( false )
				})
				.setOnError( result => {
					setLoading( false )
				})
				.execute()
			
			return;
		}
		
		setFloor( ObjectFloor.defaults )
		setLoading( false )
	}
	
	const saveForm = ( values, { callback } = {} ) => {
		values[ 'building_guid' ] = buildingGuid;
		
		new GraphqlBuilder()
			.addQuery( 'mutation', MutationManagementFloor, values )
			.setResultPath( ['mutation', 'floor'], {} )
			.setOnStart( () => {
				callback( FormStatus.LOADING )
			})
			.setOnSuccess( ( result ) => {
				MutateTranslation.mutate( tableConstants.FLOORS, result.guid, values, {
					callbackSuccess: ( t ) => {
						callback( FormStatus.SUCCESS )
						
						navigation.replace( AppRoutes.MANAGEMENT_BUILDINGS_FLOOR, {
							buildingGuid: buildingGuid,
							floorGuid: result.guid
						});
					},
					callbackError: () => {
						callback( FormStatus.ERROR )
					}
				})
			})
			.setOnError( ( result ) => {
				callback( FormStatus.ERROR )
			})
			.execute()
	}
	
	useEffect( () => {
		return fetchFloor();
	}, [ isFocused, floorGuid ] )

	let content = <LoadingComponent />
	if( !loading ) {
		content = renderTabs()
	}
	
	return (
		<ThemedSafeAreaComponentTop
			top={ false }>
			
			<ThemedLayout
				topNavigation={true}
				topNavigationProps={{
					showBackButton: true
				}}
				title={ i18n.t('management:pages.buildings.floor.title', {
					name: Translate.field( floor, 'name' ),
					interpolation: {
						escapeValue: false
					}
				})}>
				
				{ content }
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	);
}

export default ManagementBuildingFloorScene
